import React from 'react';
import { Link } from 'react-router-dom';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import TeaserPhoto from 'components/TeaserPhoto';
import { Button } from 'components/Button';
import { Skeleton } from '@mui/material';
import { times } from 'utils/render';
import './index.sass';
import Model from '../../../../model';

const { block, el } = bem('full-specialist-teaser');

export const FullSpecialistTeaser = ({ specialist }) => {
    const { name, specialisation, direction, length, slug } = specialist.data;
    const { price } = specialist.data.servicesSet[0];
    const { city, experience, workingWithPairs, photo } = specialist;
    const { openSpecialistOrderForm } = Model.modal;
    const onClick = (e) => {
        e.preventDefault();
        openSpecialistOrderForm(specialist.id);
    }
    return (
        <Layout
            slug={ slug }
            PhotoBlock={PhotoBlock({photo, name})}
            TopBlock={TopBlock({specialisation, experience, city, name})}
            DescriptionBlock={DescriptionBlock({ direction })}
            BottomBlock={BottomBlock({price, workingWithPairs, length, onClick})} />
    )
}

export const TeaserSkeleton = () => {
    const PhotoBlock = <Skeleton variant='rectangular' height={'100%'} style={{borderRadius: '20px'}}><TeaserPhoto /></Skeleton>;
    const TopBlock = <>
        <Skeleton key={1} height={10} style={{marginBottom: '5px', fontSize: '12px', lineHeight: '14px'}} width={`50%`}/>
        <Skeleton key={2} height={10} style={{marginBottom: '5px', fontSize: '24px', lineHeight: '30px'}} width={`70%`}/>
    </>
    const DescriptionBlock = times((key) => <Skeleton key={key} style={{marginBottom: '3px', fontSize: '10px', lineHeight: '12px'}} width={`${70 + Math.random() * 30}%`}/>, 3)
    const BottomBlock = <Skeleton variant='rectangular' width={'100%'} height={42} style={{borderRadius: '10px'}} />
    return (
        <Layout
            PhotoBlock={PhotoBlock}
            TopBlock={TopBlock}
            DescriptionBlock={DescriptionBlock}
            BottomBlock={BottomBlock}
        />
    )
}

const Layout = ({ slug, PhotoBlock, TopBlock, DescriptionBlock, BottomBlock }) => {
    const RootTag = slug ? Link : 'div';
    const to = slug ? `/specialists/${ slug }` : null;
    return (
        <RootTag className={ block() } to={ to }>
            <div className={ el('photo') }>
                { PhotoBlock }
            </div>
            <div className={ el('content') }>
                <div className={ el('top-block') }>
                    { TopBlock }
                    <div className={ el('description') }>{ DescriptionBlock }</div>
                </div>
                <div className={ el('bottom-block') }>
                    { BottomBlock }
                </div>
            </div>
        </RootTag>
    )
}

const PhotoBlock = ({photo, name}) => <TeaserPhoto src={ photo } alt={ `Фото специалиста ${ name }` }/>;
const TopBlock = ({specialisation, experience, city, name}) => {
    return (
        <>
            <div className={ el('first-block') }>
                <div className={ el('speciality') }><Text>{ specialisation }</Text></div>
                <div className={ el('caption') }>
                    <div className={ el('experience') }>
                        <Icon name={ 'crown-simple' }/>
                        <Text>{ experience }</Text>
                    </div>
                    { city && <div className={ el('location') }>
                        <Icon name={ 'navigation-arrow' }/>
                        <Text>{ city }</Text>
                    </div> }
                </div>
            </div>
            <div className={ el('name') }><Text serif={ true } dangerouslySetInnerHTML={ { __html: name } }/></div>
        </>
    )
}

const DescriptionBlock = ({ direction }) => <Text>{ direction }</Text>;

const BottomBlock = ({ price, workingWithPairs, length, onClick }) => {
    return (
        <>
            <div className={ el('price-block') }>
                <div className={ el('price-label') }>
                    <Text>Стоимость</Text>
                </div>
                <div className={ el('prices-list') }>
                    <div className={ el('price-single') }>
                        <Icon name={ 'user' }/>
                        <Text className={ el('price') }>{ `${ price } ₽` }</Text>
                        <Text className={ el('duration') }>{ ` ${ length } мин` }</Text>
                    </div>
                    <div className={ el('price-pair') }>
                        <Icon name={ 'users' }/>
                        <Text className={ el('price') }>{ workingWithPairs ? `${ price } ₽` : '-' }</Text>
                        { workingWithPairs && <Text className={ el('duration') }>{ ` ${ length } мин` }</Text> }
                    </div>
                </div>
            </div>
            <div className={ el('button') }>
                <Button mod={ 'transparent-gold' } onClick={ onClick }><Text>Записаться к специалисту</Text></Button>
            </div>
        </>
    )
}

